export default "__VITE_ASSET__9U2hlS8J__"